/**
 * Every feature flag that exists, with the value used when a tenant's
 * config.json doesn't mention it. Add a flag here first, then override it per
 * tenant/environment in `saas/<Tenant>/config.json`.
 *
 **/
export const DEFAULT_FEATURES = {
  /** External "Energy Usage Data" link in the side nav. */
  energyUsageDataLink: true,
  /** Guided dashboard tour: the welcome banner, the "Take a Tour" tab and the tour itself. */
  tutorial: true,
  /** Route RUM telemetry through our own /api/rum-ingest proxy instead of hitting AWS directly. */
  rumProxyEnabled: false,
  /** Bill Analyzer chatbot: the launcher button and its panel. */
  chatbot: true,
  /**
   * Load FullStory. Capture only starts once a consumer has been identified,
   * so pages without a signed-in consumer (login, logout, CSR) are never recorded.
   */
  fullStory: false,
};

export type FeatureFlags = typeof DEFAULT_FEATURES;
